var _rect, _rect2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconErase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-864 -314)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.13H3V20.13H21V18.13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8999 14.67L11.1299 16.44C10.9299 16.64 10.6199 16.64 10.4199 16.44L6.87989 12.9C6.67989 12.7 6.67989 12.39 6.87989 12.19L8.64989 10.42L7.23989 9.01001L4.14989 12.1C3.90989 12.34 3.96989 12.81 4.29989 13.13L10.1899 19.02C10.5199 19.35 10.9799 19.41 11.2199 19.17L14.3099 16.08L12.8999 14.67V14.67Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0902 9.13002L14.1902 3.24002C13.8602 2.91002 13.3202 2.93002 12.9802 3.27002L8.66016 7.60002L10.0702 9.01002L13.2502 5.83002C13.4502 5.63002 13.7602 5.63002 13.9602 5.83002L17.5002 9.37002C17.7002 9.57002 17.7002 9.88002 17.5002 10.08L14.3202 13.26L15.7302 14.67L20.0602 10.34C20.4002 10 20.4102 9.46002 20.0902 9.13002V9.13002Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.718 14.6656L8.64697 7.59448L7.23276 9.0087L14.3038 16.0798L15.718 14.6656Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErase);
export default __webpack_public_path__ + "static/media/icon-erase.c6e335c751209614d0cc8d6976c860c2.svg";
export { ForwardRef as ReactComponent };